import {styled} from '@linaria/react';
import React, {FC, Fragment} from 'react';
import {COLORS} from '../../../constants/colors';
import {mediaDesktopAndUp} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

interface TitleStyles {
  boldTitle?: boolean;
  defaultSize: keyof typeof FONT_SIZES;
  mediumSize?: keyof typeof FONT_SIZES;
  titleColor?: string;
}

interface Props extends TitleStyles {
  title: string;
  superText?: string;
  className?: string;
  style?: React.CSSProperties;
}

type AlignmentInterface = {
  bannerAlignment: 'center' | 'left';
};

const Text = styled.h4<AlignmentInterface & TitleStyles>`
  color: ${({titleColor}) => titleColor || COLORS.White};
  margin: 0;
  text-align: ${({bannerAlignment}) =>
    bannerAlignment === 'left' ? 'left' : 'center'};
`;

const Title = styled(Text)<TitleStyles>`
  font-size: ${({defaultSize}) => FONT_SIZES[defaultSize]};
  font-weight: ${props =>
    props.boldTitle ? FONT_WEIGHTS.bold : FONT_WEIGHTS.mediumBold};

  @media ${mediaDesktopAndUp} {
    font-size: ${props =>
      props.mediumSize
        ? FONT_SIZES[props.mediumSize]
        : FONT_SIZES[props.defaultSize]};
  }
`;

const Bold = styled.span`
  font-weight: ${FONT_WEIGHTS.bold};
`;

const BoldText: React.FC<{title: string}> = ({title}) => {
  return (
    <>
      {title.split('**').map((part, i) => {
        if (i % 2 === 0) {
          return <Fragment key={i}>{part}</Fragment>;
        } else {
          return <Bold key={i}>{part}</Bold>;
        }
      })}
    </>
  );
};

export const BannerTitle: FC<Props & AlignmentInterface> = ({
  title,
  superText,
  titleColor,
  boldTitle,
  bannerAlignment,
  defaultSize,
  mediumSize,
  className,
  style,
}) => {
  return (
    <Title
      data-testid="bannerTitle"
      bannerAlignment={bannerAlignment}
      boldTitle={boldTitle}
      defaultSize={defaultSize}
      mediumSize={mediumSize}
      titleColor={titleColor}
      className={className}
      style={style}
    >
      <BoldText title={title} />
      {superText && (
        <StyledSuperTag data-testid="bannerTitleSuperTag" as="sup">
          {superText}
        </StyledSuperTag>
      )}
    </Title>
  );
};

const StyledSuperTag = styled(Bold)`
  margin-left: 3px;
`;
